import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=fe08b6e4&scoped=true"
import script from "./UserAdd.vue?vue&type=script&lang=js"
export * from "./UserAdd.vue?vue&type=script&lang=js"
import style0 from "./UserAdd.vue?vue&type=style&index=0&id=fe08b6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe08b6e4",
  null
  
)

export default component.exports